import React, { useEffect, useRef, useState } from 'react'


import styles from '../../css/style.module.css'


import HOC from '../../components/HOC/HOC'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { SuccessfullyModal } from '../../components/Modals/Modals';
import { getApi, putApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';

import img2 from '../../assest/loading1.gif'
import { RiImageAddLine } from "react-icons/ri";



const EditContactDetailsOffice = () => {
    const navigate = useNavigate()
    const [show, setShow] = useState(false)
    const { id } = useParams();

    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [mobilenumber, setMoileNumber] = useState('');
    const [email, setEmail] = useState('');
    const [address, setAddress] = useState('');

    const [loading, setLoading] = useState(false);
    const [image, setImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);

    const fileInputRef = useRef(null);


    const fetchData = async () => {
        await getApi(endPoints.getcontactdetailsbyid(id), {
            setResponse: (response) => {
                setTitle(response?.data?.title || '');
                setDescription(response?.data?.description || '');
                setMoileNumber(response?.data?.mobileNumber || '');
                setEmail(response?.data?.email || '');
                setAddress(response?.data?.address || '');
                if (response?.data?.image) {
                    setImagePreview(response?.data?.image); // Set the image preview if data has an image URL
                }
            },
            setLoading,
            errorMsg: 'Failed to fetch data!',
        });
    };


    useEffect(() => {
        fetchData();
    }, [])


    const handleUpdate = async () => {
        const formData = new FormData();
        formData.append('title', title);
        formData.append('description', description);
        formData.append('mobileNumber', mobilenumber);
        formData.append('email', email);
        formData.append('address', address);
        formData.append('image', image);

        await putApi(endPoints.updatecontactdetailsOffice(id), formData, {
            setLoading,
            successMsg: 'Contact Details for office updated successfully!',
            errorMsg: 'Failed to update contact details for office!',
        });
        setShow(true);

        setTimeout(() => {
            setShow(false);
            navigate('/contact-details/office')
        }, 2000);
    };


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const handleUploadClick = () => fileInputRef.current?.click();

    const handleClearImage = () => {
        setImage(null);
        setImagePreview(null);
    };






    return (
        <>
            <SuccessfullyModal
                show={show}
                handleClose={() => setShow(false)}
                text={"Successfully Updated"}
            />
            <div className={styles.jobmanagementCotainer}>
                <div className={styles.jobtoppart}>
                    <div className={styles.pagetitle}>
                        <h6>Edit Contact Details For Office</h6>
                    </div>
                    <div className={styles.rightbuttons}>
                        <div className={styles.rightbuttons2} onClick={handleUpdate}>
                            <p>Update</p>
                        </div>
                        <div className={styles.rightbuttons}>
                            <button onClick={() => navigate(-1)}>Cancel</button>
                        </div>
                    </div>
                </div>
                <div className={styles.jobchildcontainer}>
                    <div className={styles.addcontactdetails}>
                        <div className={styles.addjobinputs}>
                            <label htmlFor="">Title*</label>
                            <input
                                type="text"
                                placeholder='Enter the title'
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                            />
                        </div>
                        <div className={styles.addjobinputs}>
                            <label htmlFor="">Mobile Number*</label>
                            <input
                                type="text"
                                placeholder='Enter the mobile number'
                                value={mobilenumber}
                                onChange={(e) => setMoileNumber(e.target.value)}
                            />
                        </div>
                        <div className={styles.addjobinputs}>
                            <label htmlFor="">Email*</label>
                            <input
                                type="email"
                                placeholder='Enter the email'
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                        <div className={styles.addjobinputs}>
                            <label htmlFor="">Address*</label>
                            <input
                                type="text"
                                placeholder='Enter the address'
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                            />
                        </div>

                    </div>
                    <div className={styles.addjobinputs}>
                        <label htmlFor="">Description*</label>
                        <textarea
                            placeholder='Enter the description'
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </div>
                    <div className={styles.addbannercontainer}>
                        <label htmlFor="">Image*</label>
                        <div className={styles.addbannerinput}>
                            {imagePreview ? (
                                <>
                                    <div className={styles.editbannerimage}>
                                        <img src={imagePreview} alt="" />
                                    </div>
                                    <span onClick={handleClearImage}>Clear</span>
                                </>
                            ) : (
                                <>
                                    <div className={styles.addbannerupload} onClick={handleUploadClick}>
                                        <RiImageAddLine color='#8D98AA' size={35} />
                                        <p>Upload your file</p>
                                    </div>
                                    <span>Max 2MB</span>
                                </>
                            )}
                        </div>
                        <input
                            type="file"
                            ref={fileInputRef}
                            onChange={handleFileChange}
                            hidden
                        />
                    </div>
                </div>
            </div >
        </>
    )
}

export default HOC(EditContactDetailsOffice)
